import { render, staticRenderFns } from "./GeneralBarChart.vue?vue&type=template&id=609679ae"
import script from "./GeneralBarChart.vue?vue&type=script&lang=js"
export * from "./GeneralBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports